import { defineMessages } from "react-intl";

export default defineMessages({
  changePaymentMethod: {
    id: "configurePreferredPaymentMethod.changePaymentMethod",
    defaultMessage: "(Change payment method)",
  },
  submit: {
    id: "configurePreferredPaymentMethod.submit",
    defaultMessage: "Submit",
  },
  noPaymentBeforeService: {
    id: "configurePreferredPaymentMethod.noPaymentBeforeService",
    defaultMessage: "No payment before the service.",
  },
  choosePaymentMethodAndPayService: {
    id: "configurePreferredPaymentMethod.choosePaymentMethodAndPayService",
    defaultMessage: "Choose your payment method and pay the service",
  },
});
